module.exports = __webpack_public_path__ + "static/media/plan.fa3902cb.svg";